export default `---
slug: neural-networks
title: "Artificial Neural Networks"
year: 2020
category: university
featured: false
tags: [Python, Deep Learning, Boltzmann Machines, Self-Organizing Maps, KTH]
thumbnail: /images/projects/6_vecho in stockholm.png
description: "KTH Erasmus: diving into neural networks with Pawel Herman and Erik Fransén — from perceptrons to Deep Belief Networks, and some very cold Swedish nights."
relatedLinks:
  - label: "Erasmus @ KTH Stockholm"
    href: /career/erasmus-kth
---

![Vecho in Stockholm](/images/projects/6_vecho in stockholm.png)

During my Erasmus in Stokholm, I decided to focus on Machine Learning *(which is the old name of AI)* and of course I could not miss Artificial Neural Networks and Deep Learning.
The class was taught by [Professor Pawel Herman](https://scholar.google.com/citations?user=usAxvpcAAAAJ&hl=en), and [Professor Erik Fransén](https://scholar.google.com/citations?user=VFtGuvcAAAAJ&hl=en), known for their years of research in the parallelism between Artificial Neural Networks and the human brain.
The class was fascinating, the lectures clears and the passion of the professors contagious.
Cherry on top, their apporach to teaching was very practical, and we had to do a lot of hands on projects.
I ended up in team with Stefano, colleague from my same class in Politecnico, Vittorio from PoliTo and Rodrigo from Lisbon.

We did a couple of projects, one was a simple image classifier, and the other was a more complex project that I do not remember well.

![SOMs gif](/images/projects/6_SOM.gif)

I would not list here the breath of the class, it is 7.5 ECTS worth of Master of Science classes, but I will mention the projects I did with my colleagues, that in the meantime became friends.
By the way, I was still new to programming, while Vittorio and Rodrigo were strong. They thought me so much, I will be forever grateful.
The first project was the introduction to Machine Learning, we covered classification and regression with single and multi layer perceptrions.
In the second project we covered unsupervised learning, implementing networs for Competitive Learning, Radial Basis Functions and Self-Organizing Maps.
The third project introduced regressive and auto-regressive networks, with various implementations of Hopfield networks.
The last project was a bit more challenging, the "warm up" were Restricted Boltzmann Machines, and then we had to implement a Deep Belief Network to classify and generate images of digits from the MNIST dataset.

I know I am repetitive, but I had so much fun learning with my colleagues, it made the Swedish winter better bearable!

![DBN images](/images/projects/6_digits.png)

***For the nerds***:
A Deep Belief Network is a stack of Boltzmann Machines, with a perceptron at one end that can work in both directions (s/o regression!).
The first direction is used to classify the input images into digits, while the second direction is used to generate images of digits.
Training happens in stages, and it takes a while if run on a regular laptop. But we were together, so we just joked around a lot.
I am too lazy to put the code on GitHub, but if only one of you asks for it I will.
`;
